module.exports = __webpack_public_path__ + "static/media/boxMobile.709bf97d.png";